<footer class="custom-data__footer">

  @if(!currentlyProcessing) {
  <h2 class="cusom-data__footer-title">
    Import {{ componentFor === DataFieldFor.Company ? "clients" : "contacts" }}
  </h2>

  <p class="custom-data__footer-description">
    Click the button bellow to import
    {{ componentFor === DataFieldFor.Company ? "clients" : "contacts" }} with
    your custom fields.
  </p>

  <csvbox-btn
    [licenseKey]="licenseKey"
    [imported]="imported"
    [user]="user"
    [dynamicColumns]="dynamicColumns"
    [componentFor]="componentFor"
    (csvboxSubmit)="handleCsvboxSubmit()"
  ></csvbox-btn>
  }

  @else {
  <div class="text-center" style="width: 600px; max-width: 100%; margin: 0 auto;">
    <ds-empty-state
      icon="tio-autorenew"
      title="Import Successful"
      [description]="
      componentFor === DataFieldFor.Company ? 
      'Your data has been imported. Please wait about a couple of minutes for Client Hub to complete processing it and creating workspaces for your clients.  You will then see these clients that you have imported from the Clients and Workspaces menu on the left side.'
      : 
      'Your data has been imported. Please wait about a couple of minutes for Client Hub to complete processing it and creating your contacts.'
      "
    ></ds-empty-state>
    
    <button class="btn btn-primary mt-4" routerLink="/practice/workspaces">
      Go to Workspaces
    </button>
  </div>
  }
</footer>
